import { useProfileData } from './useProfileData';

export const useVentureData = () => {
  const { data, loading, error, refetch } = useProfileData();

  return {
    ventureData: data,
    loading,
    error,
    refetch
  };
};